var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{on:{"click":_vm.action}},[_c('v-list-item-action',[_c('v-icon',{attrs:{"color":"white"}},[_vm._v(_vm._s(_vm.icon))])],1),_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.name))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }